import { Statistic } from 'antd';

interface IStatisticValueProps {
  premium: string | number;
}

const StatisticValue = (props: IStatisticValueProps) => {
  const { premium = 0 } = props;
  const currentLang = localStorage.getItem('selected_lang');
  return (
    <Statistic
      valueStyle={{ color: '#212121', fontSize: '16px' }}
      value={premium}
      groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
      decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
    />
  );
};

export default StatisticValue;
